var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"config":_vm.editorConfig,"editor-url":_vm.editorUrl},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.getValue),callback:function ($$v) {_vm.getValue=$$v},expression:"getValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }